/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    string, shape, arrayOf, number, object, func,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { useUIDSeed } from 'react-uid';
import withStyles from '@material-ui/core/styles/withStyles';
import GraphqlGreetingCardsContainer from './GraphqlGreetingCardsContainer';

const styles = (theme) => ({
    templatesContainer: {
        overflow: 'hidden',
        height: 'calc(95% - 110px)',
        padding: '0px 10px',
        margin: '0 auto',
        maxHeight: '100%',
        overflowY: 'auto',
        [theme.breakpoints.down('xs')]: {
            height: 'calc(90% - 110px)',
            padding: 0,
            overflowX: 'hidden',
            margin: '0 auto',
        },
    },
});
const GraphqlOccasionDataContainer = ({
    classes,
    occasions,
    selectedOccasion,
    brandUid,
    setCardTemplate,
}) => {
    const seed = useUIDSeed();
    const getGreetingCards = (occasion) => (
        <Grid key={seed(occasion)}>
            <GraphqlGreetingCardsContainer
                brandUid={brandUid}
                occasionId={occasion.uid}
                setCardTemplate={setCardTemplate}
                title={occasion.title}
            />
        </Grid>
    );

    // Sort occasions according to thier ranks
    const sortedOccasions = occasions?.sort((occasionPrev, occasionNext) => {
        const occasion1 = Number(occasionPrev?.occasions?.rank || 0);
        const occasion2 = Number(occasionNext?.occasions?.rank || 0);
        let val = 0;
        if (occasion1 < occasion2) {
            val = -1;
        }
        if (occasion1 > occasion2) {
            val =  1;
        }
        if (occasion1 === 0 || occasion2 === 0) {
            val = 0;
        }
        return val;
    });
    // Get Selected Occasion
    const selectedOccasionData = sortedOccasions?.find(
        (occasion) => occasion?.occasions?.reference?.[0]?.uid === selectedOccasion,
    )?.occasions?.reference?.[0];

    // Get all occasions
    return (
        <Grid className={classes.templatesContainer}>
            {selectedOccasion?.length
                ? getGreetingCards(selectedOccasionData)
                : sortedOccasions?.map((occasion) => (
                    getGreetingCards(occasion.occasions?.reference?.[0])
                ))}
        </Grid>
    );
};

GraphqlOccasionDataContainer.propTypes = {
    occasions: arrayOf(shape({
        occasions: shape({
            rank: number.isRequired,
        }),
        reference: arrayOf({
            uid: string.isRequired,
        }),
    })).isRequired,
    brandUid: string.isRequired,
    selectedOccasion: arrayOf(shape({
        occasions: shape({
            rank: string.isRequired,

        }),
    })),
    setCardTemplate: func.isRequired,
    classes: object.isRequired,
};

GraphqlOccasionDataContainer.defaultProps = {
    selectedOccasion: [],
};

export default withStyles(styles)(GraphqlOccasionDataContainer);
